import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type { Error } from '@eggplant/types'

interface Props {
  id: string
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => ReactElement
  shortErrorMessage?: string
}

const UnlockSutRequest = ({
  id,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${SUT_SERVICE}/suts/${id}/lock`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default UnlockSutRequest
